import { AnalyticsStore } from 'bernie-plugin-mobx';
import { History, Location } from 'history';
import { trackAnalyticsList, trackAnalytics, closeDialogs, openInSameTab, openOffer } from 'utility';
import { FlightsStoresType } from 'utility/hooks';
import { AnalyticsType } from '../types/shared/analytics';
import analyticsWrapper from 'utility/analytics-wrapper';
import { getBexApiContext } from 'bernie-context';
import TriggerFlightsSearchParams from 'types/shared/trigger-flights-search-params';

export const applySelectSheet = (
  identifier: string,
  itemIndex: number,
  stores: FlightsStoresType,
  history: History,
  location: Location,
  pwaDialog?: string,
  upsellOfferToken?: string
) => {
  const {
    dynamicElementsStore,
    analytics: analyticsStore,
    detailsAndFaresStore,
    flightsSelectedJourneyReviewStore,
    priceSummaryStore
  } = stores;

  const dynamicElementsGroupTrackEventAnalytics = dynamicElementsStore.getDynamicElementsGroupTrackEventAnalytics(
    identifier
  );
  if (dynamicElementsGroupTrackEventAnalytics) {
    const { analyticsList, stringifiedAllFlightProducts } = dynamicElementsGroupTrackEventAnalytics;
    const { linkName, referrerId } = analyticsList[0];

    analyticsStore.trackEvent(referrerId, linkName, analyticsStore.omnitureData, null, true, [
      {
        schemaName: 'allFlightProducts',
        messageContent: JSON.parse(stringifiedAllFlightProducts)
      }
    ]);
  }
  detailsAndFaresStore.cleanSelectedState();
  flightsSelectedJourneyReviewStore.updateInformation(
    itemIndex,
    identifier,
    dynamicElementsStore,
    priceSummaryStore,
    history,
    location,
    pwaDialog,
    upsellOfferToken
  );
  trackAnalyticsList(flightsSelectedJourneyReviewStore.onFareSelectAnalytics, analyticsStore);
  flightsSelectedJourneyReviewStore.cleanSelectedAnalytics();
  detailsAndFaresStore.cleanInitialSelectedFareIndex();
};

export const faresLoadingAnalyticsRender = (
  faresLoadingDisplayedAnalytics: AnalyticsType,
  faresLoadingTimeAnalytics: AnalyticsType,
  analytics
) => {
  trackAnalytics(faresLoadingDisplayedAnalytics, analytics);
  if (typeof performance?.getEntriesByName === 'function') {
    const componentRenderDuration = (
      window.performance.getEntriesByName('FareLoaderRender')[0]?.duration / 1000
    )?.toFixed(0);
    faresLoadingTimeAnalytics.referrerId = faresLoadingTimeAnalytics.referrerId.replace(
      '${X}',
      componentRenderDuration
    );
    trackAnalytics(faresLoadingTimeAnalytics, analytics);
  }
};

export const sendUisTrackEvent = (analyticsList, analyticsStore: AnalyticsStore) => {
  analyticsList.forEach(analytics => {
    const { linkName, referrerId, uisPrimeMessages } = analytics;
    uisPrimeMessages.length > 0 &&
      uisPrimeMessages.map(uisPrimeMessage =>
        analyticsStore.trackEvent(referrerId, linkName, analyticsStore.omnitureData, null, true, [
          {
            schemaName: uisPrimeMessage.schemaName,
            messageContent: JSON.parse(uisPrimeMessage.messageContent)
          }
        ])
      );
  });
};

export const onListingsFareApplied = (
  response,
  stores: FlightsStoresType,
  history: History<{}>,
  location: Location<{}>,
  isSmallViewPort?: boolean,
  isSmartListings?: boolean
) => {
  const {
    searchCriteriaStore,
    context,
    errorStore,
    multiItemStore,
    dialogsStore,
    stepIndicatorStore,
    searchResults
  } = stores;
  const { setJourneyContinuationIdInStepIndicator } = stepIndicatorStore;
  const { setIsInitialSearch } = searchResults;

  if (response.__typename === 'FlightsBoundNavigation') {
    closeDialogs({
      history,
      location,
      callback: () => {
        setTimeout(() => {
          searchCriteriaStore.prepareNavigation(response);

          const triggerSearchParams: TriggerFlightsSearchParams = {
            history,
            location,
            context,
            shouldForce: true,
            fetchSearchForm: false,
            reloadPageOnError: true
          };
          searchCriteriaStore.triggerSearch(triggerSearchParams);
        }, 50);
        setJourneyContinuationIdInStepIndicator(response.stepIndicatorJcid);
        analyticsWrapper.resetSearchResultsAnalyticsPayLoad();
      }
    });
    setIsInitialSearch(true);
  } else if (response.__typename === 'MultiItemSelectProducts') {
    if (errorStore.multiItemError) {
      errorStore.setMultiItemError(false);
    }

    multiItemStore
      .executeMultiItemSelectProduct(response, getBexApiContext(context), searchCriteriaStore.pageId)
      .then(openInSameTab)
      .catch(() => {
        errorStore.setMultiItemError(true);
      });
  } else if (response.__typename === 'MultiItemSelectPackage') {
    if (errorStore.multiItemError) {
      errorStore.setMultiItemError(false);
    }

    const multiItem = searchCriteriaStore.searchCriteria.shoppingContext?.multiItem;

    multiItemStore
      .executeMultiItemSelectPackage(response, multiItem.id, getBexApiContext(context), searchCriteriaStore.pageId)
      .then(openInSameTab)
      .catch(() => {
        errorStore.setMultiItemError(true);
      });
  } else if (response.__typename === 'FlightsNavigateToDetails') {
    const relativePath = response.nextPage.__typename === 'HttpURI' ? response.nextPage.relativePath : null;
    const packageUrl = response.packagesUrl?.__typename === 'HttpURI' ? response.packagesUrl.relativePath : null;

    setTimeout(() => {
      const isForcedChoiceModalDisabled = !dialogsStore.isForcedChoiceEnabled || isSmallViewPort || packageUrl === null;
      if (isForcedChoiceModalDisabled) {
        openOffer(relativePath, isSmallViewPort);
      } else {
        dialogsStore.updateForcedChoiceModal(relativePath, packageUrl);
      }
    }, 50);
  } else {
    if (isSmartListings) {
      const { dialogSideSheet, searchCriteria } = searchCriteriaStore;
      setTimeout(() => {
        searchCriteriaStore.sideSheetQueryContext.journeyContinuationId = response;
        dialogSideSheet.searchFilterValuesList = JSON.parse(JSON.stringify(searchCriteria.searchFilterValuesList));
        dialogSideSheet.addOnRequested = JSON.parse(
          JSON.stringify(searchCriteriaStore.sideSheetQueryContext.addOnRequested)
        );
      }, 10);
    }
  }
};
